import { getUserToken } from "../../libs/user";
import {
  fireReloginPopup,
  getPureJSON,
  handleAPIError,
  handleError,
  startLoader,
  stopLoader,
} from "../../libs/utils";
import {
  makeGetRequest,
  makePostRequest,
  makePutRequest,
  makeDeleteRequest
} from "../makeRequest";
import config from "../../config/app.config";

const BASE_URL = `${config.apiUrl.activityapi}`;

// Create a new activity (multiple platforms)
export const createActivity = async (data) => {
  try {
    const response = await makePostRequest(BASE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get all activities (grouped)
export const getActivityList = async () => {
  try {
    const response = await makeGetRequest(BASE_URL);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get activity by spacode (id)
export const getActivityById = async (id) => {
  try {
    const response = await makeGetRequest(`${BASE_URL}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update activity for a specific platform
export const updateActivity = async (id, data) => {
  try {
    const response = await makePutRequest(`${BASE_URL}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// (Optional) Delete activity
export const deleteActivity = async (id) => {
  try {
    const response = await makeDeleteRequest(`${BASE_URL}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCategoryTitle = async (id) => {
  try {
    const response = await makeGetRequest(`${BASE_URL}/category/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
